"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _searchWebHost = 'http://www.local.aperza.com:8080';
var AperzaLinkUtil = /** @class */ (function () {
    function AperzaLinkUtil() {
    }
    Object.defineProperty(AperzaLinkUtil, "searchWebHost", {
        set: function (value) {
            _searchWebHost = value;
        },
        enumerable: true,
        configurable: true
    });
    AperzaLinkUtil.createCompanyPageUrl = function (_a) {
        var companyContractDisplayId = _a.companyContractDisplayId;
        return _searchWebHost + "/co/" + companyContractDisplayId;
    };
    AperzaLinkUtil.createCatalogPageUrl = function (_a) {
        var companyContractDisplayId = _a.companyContractDisplayId, catalogId = _a.catalogId, _b = _a.lang, lang = _b === void 0 ? 'ja' : _b;
        return _searchWebHost + "/" + lang + "/co/" + companyContractDisplayId + "/catalog/" + catalogId;
    };
    return AperzaLinkUtil;
}());
exports.default = AperzaLinkUtil;
//# sourceMappingURL=AperzaLinkUtil.js.map